"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = {
  setAllLoading: function setAllLoading() {
    return {
      type: 'ARTICLES_ALL_LOADING'
    };
  },
  getList: function getList(data) {
    return request.post('articles', data, function (res, dispatch) {
      var data = res.data,
        items = data.items,
        filter = data.filter,
        pagination = data.pagination;
      if (!items) items = [];
      dispatch({
        type: 'ARTICLES_ALL',
        items: items,
        filter: filter,
        pagination: pagination
      });
      return res;
    });
  }
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJzZXRBbGxMb2FkaW5nIiwidHlwZSIsImdldExpc3QiLCJkYXRhIiwicmVxdWVzdCIsInBvc3QiLCJyZXMiLCJkaXNwYXRjaCIsIml0ZW1zIiwiZmlsdGVyIiwicGFnaW5hdGlvbiJdLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uLy4uL2xpYnJhcnkvc3JjL2NsaWVudC9tb2R1bGVzL0NvbnRlbnQvQXJ0aWNsZS9BcnRpY2xlQWN0aW9ucy5qcyJdLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZGVmYXVsdCB7XHJcbiAgICBzZXRBbGxMb2FkaW5nOiAoKSA9PiB7XHJcbiAgICAgICAgcmV0dXJuIHt0eXBlOiAnQVJUSUNMRVNfQUxMX0xPQURJTkcnfTtcclxuICAgIH0sXHJcbiAgICBnZXRMaXN0OiAoZGF0YSkgPT4gcmVxdWVzdC5wb3N0KCdhcnRpY2xlcycsIGRhdGEsIChyZXMsIGRpc3BhdGNoKSA9PiB7XHJcbiAgICAgICAgbGV0IGRhdGEgPSByZXMuZGF0YSxcclxuICAgICAgICAgICAgaXRlbXMgPSBkYXRhLml0ZW1zLFxyXG4gICAgICAgICAgICBmaWx0ZXIgPSBkYXRhLmZpbHRlcixcclxuICAgICAgICAgICAgcGFnaW5hdGlvbiA9IGRhdGEucGFnaW5hdGlvbjtcclxuICAgICAgICBpZiAoIWl0ZW1zKSBpdGVtcyA9IFtdO1xyXG4gICAgICAgIGRpc3BhdGNoKHt0eXBlOiAnQVJUSUNMRVNfQUxMJywgaXRlbXMsIGZpbHRlciwgcGFnaW5hdGlvbn0pO1xyXG4gICAgICAgIHJldHVybiByZXM7XHJcbiAgICB9KSxcclxufVxyXG4iXSwibWFwcGluZ3MiOiI7Ozs7OztvQ0FBZTtFQUNYQSxhQUFhLEVBQUUsU0FBQUEsY0FBQSxFQUFNO0lBQ2pCLE9BQU87TUFBQ0MsSUFBSSxFQUFFO0lBQXNCLENBQUM7RUFDekMsQ0FBQztFQUNEQyxPQUFPLEVBQUUsU0FBQUEsUUFBQ0MsSUFBSTtJQUFBLE9BQUtDLE9BQU8sQ0FBQ0MsSUFBSSxDQUFDLFVBQVUsRUFBRUYsSUFBSSxFQUFFLFVBQUNHLEdBQUcsRUFBRUMsUUFBUSxFQUFLO01BQ2pFLElBQUlKLElBQUksR0FBR0csR0FBRyxDQUFDSCxJQUFJO1FBQ2ZLLEtBQUssR0FBR0wsSUFBSSxDQUFDSyxLQUFLO1FBQ2xCQyxNQUFNLEdBQUdOLElBQUksQ0FBQ00sTUFBTTtRQUNwQkMsVUFBVSxHQUFHUCxJQUFJLENBQUNPLFVBQVU7TUFDaEMsSUFBSSxDQUFDRixLQUFLLEVBQUVBLEtBQUssR0FBRyxFQUFFO01BQ3RCRCxRQUFRLENBQUM7UUFBQ04sSUFBSSxFQUFFLGNBQWM7UUFBRU8sS0FBSyxFQUFMQSxLQUFLO1FBQUVDLE1BQU0sRUFBTkEsTUFBTTtRQUFFQyxVQUFVLEVBQVZBO01BQVUsQ0FBQyxDQUFDO01BQzNELE9BQU9KLEdBQUc7SUFDZCxDQUFDLENBQUM7RUFBQTtBQUNOLENBQUMifQ==